import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  ApiService,
  Conference,
  Cluster,
  DateTimeFrame,
  LocalStorageService,
} from '../../../shared';

@Component({
  selector: 'app-my-cluster-schedule-page',
  templateUrl: './my-cluster-schedule-page.component.html'
})
export class MyClusterSchedulePageComponent implements OnInit {
  title: string = 'schedule';
  subtitle: string = 'lórien today'
  cluster: Cluster;
  conferences$: Observable<Conference[]>;
  dataTimeFrame$: Observable<DateTimeFrame>;

  constructor(
    private apiService: ApiService,
    private storageService: LocalStorageService,
  ) {}

  ngOnInit() {
    this.conferences$ = this.storageService.getClusterName()
      .switchMap(clusterName => {
        return this.getCluster(clusterName);
      })
      .switchMap(cluster => {
        this.cluster = cluster;
        this.subtitle = `${cluster.name} today`;
        return this.getClusterConferences(cluster.name);
      })
    this.dataTimeFrame$ = this.getDateTimeFrame();
  }

  getCluster(clusterName) {
    return this.apiService.getCluster(clusterName);
  }

  getClusterConferences(clusterName) {
    return this.apiService.getClusterConferences(clusterName);
  }

  getDateTimeFrame() {
    return this.apiService.getDateTimeFrame();
  }

}



// WEBPACK FOOTER //
// ./src/app/schedule/pages/my-cluster-schedule-page/my-cluster-schedule-page.component.ts